import { VbzButton, VbzModal } from '@smiles/voebiz-ui-kit';
import React, { FC } from 'react';
import { ModalBody } from 'reactstrap';
import { success } from '../../assets';

interface ModalSuccessProps {
  isOpenModalSuccess: boolean;
  toggleModalSuccess: () => void;
}

const ModalSuccess: FC<ModalSuccessProps> = ({ isOpenModalSuccess, toggleModalSuccess }) => {
  return (
    <>
      <VbzModal isOpen={isOpenModalSuccess} type="right" desktopSize="small" toggle={toggleModalSuccess}>
        <ModalBody>
          <div className="modal-success__image">
            <img src={success} alt="imagem de uma cadeira de praia" />
          </div>
          <div className="modal-success__title">
            <h3>Participação Confirmada!</h3>
          </div>

          <div className="modal-success__description">
            <p>Você se cadastrou na promoção.</p>
            <p>Acumule pontos, resgate passagens e aproveite os benefícios de ser cliente VoeBiz!</p>
          </div>
          <div className="continue-modal-btn">
            <VbzButton
              id="error-modal-btn"
              className="error-modal-button"
              color="primary"
              text="Continuar"
              onClick={toggleModalSuccess}
            />
          </div>
        </ModalBody>
      </VbzModal>
    </>
  );
};
export default ModalSuccess;
